import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { RecommendationItemResponse } from 'src/types/recommendation_items';
import axiosInstance from 'src/utils/axios';

interface UseRecommendationItemMutationOptions {
  onSuccess?: (data: any, request: RecommendationItemRequest) => void;
  onError?: (error: any) => void;
}

interface RecommendationItemRequest {
  items: {
    supplierCompanyId: number;
    itemNumber: string;
    price: number;
    uom: string;
  }[];
  buyerClientId?: number;
  buyerCompanyId?: number;
}
const useRecommendationItemMutation = ({
  onSuccess,
  onError,
}: UseRecommendationItemMutationOptions = {}) => {
  const mutation = useMutation({
    mutationFn: async (request: RecommendationItemRequest) => {
      const response = await axiosInstance.post(api.getRecommendedItems, request);
      return response.data as RecommendationItemResponse[];
    },
    onSuccess: (data, request) => {
      onSuccess?.(data, request);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useRecommendationItemMutation;
